import React, {ReactNode} from 'react';
import {Redirect, Route, RouteComponentProps, Switch} from 'react-router-dom';
import PageNotFound from '../page-not-found/PageNotFound';
import {KeyedRouteProps} from '../routes.model';
import {RoutesPaths} from '../routes.paths';

interface Props {
  routes: KeyedRouteProps[];
  isLogged?: boolean;
  isEnabledDisbursement?: boolean;
}

const RenderRoutes = ({routes, isLogged, isEnabledDisbursement}: Props): React.ReactElement => {
  const renderFunc = (route: KeyedRouteProps): (props: RouteComponentProps) => ReactNode => route.render ?? (
    (props: RouteComponentProps): ReactNode => {
      if (!route.component) {
        throw new Error('Render or component property must be provided in route configuration');
      }

      if (route.secured && !isLogged) {
        return <Redirect push={false} to={RoutesPaths.LOGIN} />;
      }

      if (route.isEnableDisbursementRequired && isEnabledDisbursement === false) {
        return <Redirect push={false} to={RoutesPaths.ROOT} />;
      }

      return <route.component {...props} />;
    });

  const handleRootPath = (): React.ReactElement | void => {
    const isPathRoot = window.location.pathname === RoutesPaths.ROOT;

    if (!isLogged) {
      return <Redirect push={false} to={RoutesPaths.LOGIN} />;
    }

    if (isPathRoot && isLogged) {
      return <Redirect push={false} to={RoutesPaths.ROOT} />;
    }
  };

  return (
    <Switch>
      {
        routes.map(route => <Route key={route.key} path={route.path} exact={route.exact} render={renderFunc(route)} />)
      }
      {handleRootPath()}
      <Route component={PageNotFound} />
    </Switch>
  );
};

export default RenderRoutes;
